import axios from 'axios';
import { saveBlob } from '../utils/saveBlob';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://reporting-api.diplomacy.edu';

const httpApi = axios.create({ baseURL: API_BASE_URL });

httpApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('diploAccessKey');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let isRedirecting = false;

const logoutAndRedirect = () => {
  if (isRedirecting || window.location.pathname === '/login') return;
  isRedirecting = true;
  localStorage.removeItem('diploAccessKey');
  localStorage.removeItem('diploAccessUser');
  document.cookie.split(';').forEach((c) => {
    document.cookie = c
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
  setTimeout(() => {
    window.location.href = '/login';
    isRedirecting = false;
  }, 2000);
};

const loginErrorMessage = (data) => {
  const message = (typeof data?.detail === 'string' && data.detail)
    || data?.message
    || (typeof data === 'string' && data)
    || 'Invalid login credentials';
  return /korisničko ime|username/.test(message) ? 'Incorrect username or password' : message;
};

httpApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data;
    const status = error.response?.status;

    if (status === 401) {
      if (error.config?.url?.includes('/api/auth/login')) {
        return Promise.reject(new Error(loginErrorMessage(data)));
      }
      logoutAndRedirect();
      return Promise.reject(new Error('Session expired. Redirecting to login...'));
    }
    if (status === 403) {
      logoutAndRedirect();
      return Promise.reject(new Error('Access denied. You do not have permission to access this resource.'));
    }
    return Promise.reject(Object.assign(new Error(data?.detail || data?.message || error.message), { status, data }));
  }
);

export const apiClient = {
  get: (url, config) => httpApi.get(url, config),
  post: (url, data, config) => httpApi.post(url, data, config),
  put: (url, data, config) => httpApi.put(url, data, config),
  delete: (url, config) => httpApi.delete(url, config),
  patch: (url, data, config) => httpApi.patch(url, data, config),
};

const filenameFromDisposition = (header) => {
  const encoded = (header || '').match(/filename\*=UTF-8''([^;\n]+)/i);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim());
    } catch {
    }
  }
  return (header || '').match(/filename="?([^";\n]+)"?/)?.[1];
};

export const downloadFile = async (path, { params, filename, fallbackName, mimeType } = {}) => {
  const response = await apiClient.get(path, { responseType: 'blob', params });
  const blob = new Blob([response.data], mimeType ? { type: mimeType } : undefined);
  saveBlob(blob, filename || filenameFromDisposition(response.headers['content-disposition']) || fallbackName || 'download');
  return response;
};
